/* eslint-disable @typescript-eslint/naming-convention */
import {
  DirectScheduleLocation,
  IDirectScheduleLocationAPIResponse
} from '@sondermind/utilities/models-direct-scheduling';

import { VideoVendor } from '@sondermind/utilities/models-session';

import { IAppointment } from './appointment.interface';

export class Appointment implements IAppointment {
  id: number;
  startTime: Date;
  endTime: Date;
  title: string;
  description: string;
  canceled: boolean;
  sessionType: string;
  directScheduled: boolean;
  personaProviderId: number;
  providerUserId: number;
  providerDisplayName: string;
  platformAccountUuid: string;
  location: DirectScheduleLocation;
  eventState: string;
  proposalStatus: string;
  videoVendor: VideoVendor;

  constructor(json: IAppointmentApiResponse) {
    if (!json) { return }

    this.id = json.id;
    this.startTime = new Date(json.start_time);
    this.endTime = new Date(json.end_time);
    this.title = json.title;
    this.description = json.description;
    this.sessionType = json.session_type;
    this.directScheduled = json.direct_scheduled;
    this.canceled = json.canceled;
    this.personaProviderId = json.persona_provider_id;
    this.providerUserId = json.provider?.user_id;
    this.platformAccountUuid = json.provider?.provider_account_id;
    this.providerDisplayName = json.provider?.display_name;
    this.location = new DirectScheduleLocation(json.location);
    this.eventState = json.event_state;
    this.proposalStatus = json.proposal_status;
    this.videoVendor = json.event_video_vendor;
  }
}

export interface IAppointmentApiResponse {
  id: number;
  start_time: string;
  end_time: string;
  title: string;
  description: string;
  canceled: boolean;
  direct_scheduled: boolean;
  session_type: string;
  persona_provider_id: number;
  provider: ITherapistAppointmentApiResponse;
  location: IDirectScheduleLocationAPIResponse;
  event_state: string;
  proposal_status: string;
  event_video_vendor: VideoVendor;
}

interface ITherapistAppointmentApiResponse {
  id: number;
  user_id: number;
  first_name: string;
  middle_name: string;
  last_name: string;
  display_first_name: string;
  display_last_name: string;
  display_name: string;
  practice_name: string;
  profile_photo_url: string;
  provider_account_id: string;
}

export interface ISchedulingSagaErrorApiResponse {
  persona_provider_ids: number[];
}
